import { ReactElement } from 'react';
import cx from 'clsx';
import { Sprinkles } from '@ff-it/ui';
import { TitleContainer, Title, SubTitle, TitleContainerProps } from 'components/TitleContainer';
import { genericProduct, customProduct } from './style.css';
import type { EmbeddedProduct } from '..';

export type ProductTitleProps = {
  product: Pick<EmbeddedProduct, 'id' | 'name' | 'outlet_or_service_category' | 'disabled'>;
  className?: string;
  size?: TitleContainerProps['size'];
  customProductName?: string;
} & Sprinkles;

export function ProductName({
  name,
  size,
  customProductName,
  asTitle,
}: {
  name?: string;
  size?: TitleContainerProps['size'];
  customProductName?: string;
  asTitle?: boolean;
}): ReactElement {
  const isGeneric = !name;
  const isCustom = !!customProductName;

  const productName = customProductName ? customProductName : name || 'Generic product';
  const C = asTitle ? Title : SubTitle;
  return (
    <C className={cx('product', { [genericProduct]: isGeneric, [customProduct]: isCustom })} size={size} title={name}>
      {productName}
    </C>
  );
}

export function ProductTitle({
  product: { id, name, outlet_or_service_category: oosc, disabled },
  className,
  size,
  customProductName,
  ...rest
}: ProductTitleProps): ReactElement {
  const mediaTitle = oosc.vendor && oosc.vendor.name !== oosc.name ? `${oosc.vendor.name} / ${oosc.name}` : oosc.name;

  return (
    <TitleContainer
      className={cx('product-title', className)}
      data-testid={`product-${id}`}
      disabled={disabled}
      {...rest}
    >
      <Title className="outlet-or-service-category" size={size} title={mediaTitle}>
        {mediaTitle}
      </Title>
      <ProductName name={name} customProductName={customProductName} size={size} />
    </TitleContainer>
  );
}
